import { miniBeanBiddingApi } from '../../api/miniBeanBidding';
import { message, confirm } from './utils';
const { getPlans, deletePlan, switchPlan } = miniBeanBiddingApi;
const BUDGET_TYPE = {
  1: '日预算',
  2: '总预算',
};
export default {
  data() {
    return {
      activeName: 'plan',
      plan_page: 1,
      plan_page_size: 10,
      plan_total: 0,
      plans: [],
      dataLoading: false,
      plan_columns: [
        {
          label: '计划ID',
          prop: 'id',
        },
        {
          label: '推广开关',
          prop: 'switch',
        },
        {
          label: '提交时间',
          prop: 'create_time_str',
          width: '160px',
        },
        {
          label: '推广时间',
          prop: 'promotion_time',
          width: '320px',
        },
        {
          label: '预算',
          prop: 'budget_desc',
          width: '160px',
        },
        {
          label: '推广状态',
          prop: 'ad_status',
        },
        {
          label: '操作',
          prop: 'action',
          width: '240px',
        },
      ],
      showTips: false,
      tips: '1.xxxxxx\n2.xxxxxx\n3.xxxxxx',
    };
  },
  computed: {},
  created() {
    this.getPlanList();
    const userInfo = this.getUserInfo();
    let noFirstTimeEnter = localStorage.getItem(
      `miniBeanPromotionPlanNoFirstTimeEnter_${userInfo.uin}`,
    );
    if (!noFirstTimeEnter) {
      this.showTips = true;
      localStorage.setItem(
        `miniBeanPromotionPlanNoFirstTimeEnter_${userInfo.uin}`,
        1,
      );
    }
  },
  filters: {
    adStatusText(status) {
      if (status == 1) {
        return '待推广';
      } else if (status == 2) {
        return '推广中';
      } else if (status == 3) {
        return '推广结束';
      }
    },
  },
  methods: {
    getUserInfo() {
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        if (typeof userInfo === 'string') {
          return JSON.parse(userInfo);
        } else {
          return userInfo;
        }
      }
      return {};
    },
    formatTime(time) {
      if ((time + '').length === 10) {
        time = time * 1000;
      }
      return new Date(time).toLocaleString();
    },
    getPlanList() {
      this.dataLoading = true;
      getPlans({ page: this.plan_page, page_size: this.plan_page_size })
        .then(res => {
          console.log('getPlanList---->', res);
          const { code, data } = res;
          const { list, page_count } = data;
          if (code === 0) {
            this.plans = (list || []).map(item => {
              item.budget_desc = `${BUDGET_TYPE[item.budget_type]} ${
                item.budget
              }`;
              item.promotion_time = `${this.formatTime(
                item.start_time,
              )} -- ${this.formatTime(item.end_time)}`;
              item.create_time_str = this.formatTime(item.create_time);
              return item;
            });
            this.plan_total = page_count;
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    handleTabClick(tab, event) {
      console.log(tab, event);
    },
    modifyPlan(row) {
      console.log('modifyPlan---->', row);
      this.$router.push({
        name: 'MiniBeanBiddingEdit',
        params: { id: row.id },
      });
    },
    switchPlanState(row) {
      if (row.end_time * 1000 < new Date().getTime()) {
        message(this, '当前计划已结束', 'error');
        return;
      }
      switchPlan({ id: row.id, switch: row.switch }).then(res => {
        if (res.code === 0) {
          message(this, '操作成功');
        } else {
          message(this, res.msg, 'error');
        }
        this.getPlanList();
      });
    },
    cancelPlan(row) {
      confirm(this, '确定要删除该计划吗?').then(() => {
        deletePlan({ id: row.id }).then(res => {
          if (res.code === 0) {
            message(this, '删除成功');
            this.getPlanList();
          } else {
            message(this, res.msg, 'error');
          }
        });
      });
    },
    showDetail(row) {
      console.log('show MiniBeanBidding Detail---->', row);
      this.$router.push({
        name: 'MiniBeanBiddingDetail',
        params: { id: row.id },
      });
    },
    addPlan() {
      this.$router.push({ name: 'MiniBeanBiddingAdd' });
    },
    handlePlanCurrentChange(val) {
      console.log('handlePlanCurrentChange---->', val);
      this.plan_page = val;
      this.getPlanList();
    },
    handlePlanSizeChange(val) {
      console.log('handlePlanSizeChange---->', val);
      this.plan_page_size = val;
      this.plan_page = 1;
      this.getPlanList();
    },
  },
};
